module.exports = __webpack_public_path__ + "static/img/bg-id.f714cd74.webp";